import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEqual } from 'lodash'
import { initializePayment, quotePayment } from '../actions/programRegistrationActions'
import { selectConsumerPlan, selectQuoteParams, selectRegistrationOrder } from '../reducers/programRegistrationReducer'

const usePaymentSession = () => {
  const dispatch = useDispatch()
  const consumerPlan = useSelector(selectConsumerPlan)
  const order = useSelector(selectRegistrationOrder)
  const quoteParams = useSelector(selectQuoteParams)
  const { paymentSession, selectedPaymentMethod } = useSelector(state => state.programRegistration)
  const usesPaymentSession = consumerPlan || selectedPaymentMethod === 'card'

  useEffect(() => {
    if (usesPaymentSession && paymentSession?.order !== order) {
      dispatch(initializePayment(order))
    }
  }, [usesPaymentSession, paymentSession?.order, order, dispatch])

  useEffect(() => {
    if (!usesPaymentSession || paymentSession?.status !== 'ready' || !selectedPaymentMethod) {
      return
    }
    const quote = paymentSession.quote
    if (!quote || (quote.status === 'ready' && !isEqual(quote.params, quoteParams))) {
      dispatch(quotePayment({ registrationId: paymentSession.registrationId, ...quoteParams }))
    }
  }, [usesPaymentSession, paymentSession, quoteParams, selectedPaymentMethod, dispatch])
}

export default usePaymentSession
